import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to develop a React Native mobile app?",
    answer: ` <p>The complexity of your business requirements greatly influences the entire cost of developing a React Native App, but TekRevol guarantees lower charges, with rates starting at $35 per hour.</p>`,
  },
  {
    question: " How much does it cost to hire a React Native developer?",
    answer: `<p>The cost of hiring a React Native developer varies depending on their expertise level, location, and project complexity. If you hire our skilled React app developers, the hourly rate might range from $25 to $49 per hour.</p>`,
  },
  {
    question: "What are React Native app development services?",
    answer: `<p>React Native is a framework for creating cross-platform mobile apps with JavaScript. In short, React Native basic concept is to use JSX to construct multiplatform UI components that are then spanned to native code and transformed into Android and iOS views.</p>`,
  },
  {
    question: " What is React Native app development?",
    answer: `<p>React Native development is the process of building mobile apps using the React Native framework. Developers can develop cross-platform mobile apps with JavaScript and React, writing code once and deploying it on both iOS and Android, saving time and money.</p>`,
  },
  {
    question: "Is it possible to run custom native code in React Native?",
    answer: `<p>React Native makes it easy to integrate custom native code with Native Modules, giving you seamless access to platform-specific APIs and functionality.
    By integrating JavaScript with native code (Java for Android and Objective-C/Swift for iOS), developers enhance React Native apps with native features.</p>`,
  },
  {
    question: "How long does it take to build a React Native app?",
    answer: `<p>The complexity and size of the project determine how long it takes to create a React Native application. A simple React Native app may be developed in a few weeks to a few months, on average, depending on the resources and experience. However, more complicated apps could take longer to develop.</p>`,
  },
  {
    question: "Is React Native a hybrid app development?",
    answer: `<p>Yes, React Native is a framework for developing hybrid apps that lets developers create code only once and then publish it to both the iOS and Android platforms, giving users a native-like experience.
    </p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
